import styles from './MiniProductsList.module.scss';
import React from 'react';
import { Anchor } from '@zooplus/ui-components';
import { ArticleImage } from '../article-image/ArticleImage';
import { RemainingArticles } from '../remaining-articles/RemainingArticles';
import { OfferArticle } from '../../../model/order';
import useMedias from '../../../hooks/useMedias';

export type ProductsListProps = {
  products: OfferArticle[];
  hasAnchor: boolean;
  orderId?: number;
};

export const MiniProductsList = (props: ProductsListProps) => {
  const { isSmallMobile, isMobile, isTablet, isBigDesktop } = useMedias();
  const miniProduct = (index: number, threshold: number, article: OfferArticle) => {
    if (index <= threshold) {
      return (
        <li
          id={article.articleShopId.toString()}
          key={article.articleShopId.toString()}
          data-testid={article.articleShopId}>
          {props.hasAnchor ? (
            <Anchor href={`/account/orders/detail/${props.orderId}`}>
              {index < threshold ? (
                <ArticleImage pictureUrl={article.pictureUrl} hasAusIcon={true} small={true} />
              ) : (
                <RemainingArticles itemsLeft={props.products.length - threshold} />
              )}
            </Anchor>
          ) : (
            <>
              {index < threshold ? (
                <ArticleImage pictureUrl={article.pictureUrl} hasAusIcon={true} small={true} />
              ) : (
                <RemainingArticles itemsLeft={props.products.length - threshold} />
              )}
            </>
          )}
        </li>
      );
    } else return;
  };

  const numberOfArticlesToShow = isSmallMobile
    ? 1
    : isMobile
      ? 3
      : isTablet || isBigDesktop
        ? 7
        : 4;

  return (
    <ul className={styles.articlesWrapper}>
      {props.products.map((article, index) => {
        return miniProduct(index, numberOfArticlesToShow, article);
      })}
    </ul>
  );
};
